import { RuleGroupType } from 'react-querybuilder';

/**
 * Converts react-querybuilder RuleGroupType to MongoDB query format
 * @param queryGroup RuleGroupType from react-querybuilder
 * @returns MongoDB query object
 */
export function ruleGroupToMongoDBQuery(queryGroup: RuleGroupType): any {
  if (!queryGroup.rules || queryGroup.rules.length === 0) {
    return {};
  }

  const conditions = queryGroup.rules.map((rule: any) => {
    if (rule.rules) {
      // This is a nested group
      return ruleGroupToMongoDBQuery(rule);
    } else {
      // This is a rule with field, operator, value
      const { field, operator, value } = rule;

      if (!field || !operator) {
        return { $expr: true };
      }

      // Map operators to MongoDB operators
      const operatorMap: Record<string, string> = {
        eq: '$eq',
        ne: '$ne',
        gt: '$gt',
        gte: '$gte',
        lt: '$lt',
        lte: '$lte',
        in: '$in',
        nin: '$nin',
        regex: '$regex',
        exists: '$exists'
      };

      const mongoOperator = operatorMap[operator] || '$eq';

      // Handle different value types
      let mongoValue = value;
      if (operator === 'regex') {
        mongoValue = { $regex: value };
      } else if (operator === 'in' || operator === 'nin') {
        // Handle both string (comma-separated) and array values
        if (Array.isArray(value)) {
          mongoValue = value;
        } else if (typeof value === 'string') {
          mongoValue = value.split(',').map((v: string) => v.trim());
        } else {
          mongoValue = [value];
        }
      } else if (operator === 'exists') {
        mongoValue = value === 'true';
      } else if (typeof value === 'string' && !isNaN(Number(value))) {
        mongoValue = Number(value);
      }

      return { [field]: { [mongoOperator]: mongoValue } };
    }
  });

  // Apply combinator
  if (queryGroup.combinator === 'or') {
    return { $or: conditions };
  } else {
    return { $and: conditions };
  }
}
